import * as React from "react";
import { useAuth } from "../../contexts/session_context";
export const Header = (): JSX.Element => {
    const {app_configuration} = useAuth();
    if(app_configuration && app_configuration.landing_page_image_url && app_configuration.header_background_color) {
        return (
            <React.Fragment>
                <header>
                    <div className="templatizable" style={{textAlign : "center", width : "100%", backgroundColor : app_configuration.header_background_color }}>
                        <img alt="CardUpdatr" style={{maxWidth : "100%", height : "auto"}} src={`${app_configuration.landing_page_image_url}`} />
                    </div>
                </header>
            </React.Fragment>
        );
    } else {
        return null;
    }
};